import { useRef } from 'react';
import { cn } from '~/lib/utils';
import { Carousel, CarouselContent, CarouselDots, CarouselItem } from '../ui/carousel';

interface Params {
  images: { src: string; alt: string }[];
}

function Image({ src, alt }: { src: string; alt: string }) {
  return (
    <img className={cn('w-full h-full md:max-w-[640px] md:max-h-[640px]')} src={src} alt={alt} />
  );
}

export default function ImagesCarousel({ images }: Params) {
  const ref = useRef<HTMLDivElement>(null);
  if (!images.length) return null;
  if (images.length === 1) {
    const image = images.at(0)!;
    return <Image src={image.src} alt={image.alt} />;
  }
  return (
    <div>
      <Carousel ref={ref}>
        <CarouselContent>
          {images.map(image => (
            <CarouselItem key={image.src}>
              <Image src={image.src} alt={image.alt} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselDots />
      </Carousel>
    </div>
  );
}
